import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterLink } from '@angular/router'
import { DataMap } from '@grapecity/wijmo.grid'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, EquipmentFilter, Grid, ListItem, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { EquipmentFilterModalComponent } from './equipment-filter-modal.component'
import { PartsFluidsEquipmentContext } from './parts-fluids-equipment-context'

@Component({
    selector: 'app-equipment-filter-list',
    templateUrl: './equipment-filter-list.component.html',
    standalone: true,
    imports: [
        FormsModule,
        RouterLink,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjGridFilterModule,
        AutoSizeDirective,
    ],
})
export class EquipmentFilterListComponent extends BaseComponent implements OnChanges {
    @Input() canEdit = false
    @Input() equipmentOptions: ListItem<string>[] = []
    @Input() equipmentDataMap!: DataMap
    @Input() allItems: EquipmentFilter[] = []
    @Input() parent!: PartsFluidsEquipmentContext

    grid: Grid<EquipmentFilter>

    constructor() {
        super()
        this.grid = new Grid<EquipmentFilter>(this.services, 'equipment', this)
            .setupModalEditing(
                this.services.data.equipmentFilters,
                'Filter',
                EquipmentFilterModalComponent,
                () => {
                    const item = new EquipmentFilter()
                    item.id = crypto.randomUUID()
                    return item
                },
                this,
                ModalSize.extraLarge,
            )
            .filterBy(item => [
                item.equipment,
                item.filterType,
                item.oemPartNumber,
                item.baldwinPartNumber,
                item.napaPartNumber,
                item.wheelerPartNumber,
            ])
    }

    ngOnChanges() {
        this.grid.items = this.allItems
    }
}
